import { render, staticRenderFns } from "./completedTasks.vue?vue&type=template&id=8850f6b8&scoped=true&"
import script from "./completedTasks.vue?vue&type=script&lang=js&"
export * from "./completedTasks.vue?vue&type=script&lang=js&"
import style0 from "./completedTasks.vue?vue&type=style&index=0&id=8850f6b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8850f6b8",
  null
  
)

export default component.exports